import { Effect } from 'effect';

import { deleteProductsFromFavouriteList } from '../../flow/favourites/deleteProductsFromFavouriteList';
import type { DeleteProductsFromFavouriteListInput } from '../../request/backendApi/favourites/deleteProductsFromFavouriteList';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';

export const deleteProductsFromFavouriteListAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (params: DeleteProductsFromFavouriteListInput) {
    return yield* deleteProductsFromFavouriteList(params);
  })
);
